export default __webpack_public_path__ + "static/media/pause.a290da9f.svg";